export default __webpack_public_path__ + "static/media/EnergieVerde.9dd63d03.svg";